import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./header.scss";

const Header = () => {
  const { callMenu } = useContext(Context);

  return (
    <header id="header" className="header">
      <div className="container">
        <div className="nav-bar">
          <p className="logo">AI</p>
          <button onClick={() => callMenu()} className="menu-button">
            menu
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;